<!-- 页面底部 -->
<template>
  <div class="bsk_footer">
    <div style="display: flex;flex-direction: row">
      <a style="font-size: 12px;color: #BDBDBD">Copyright © 2023 winlesson.com 必胜公考 版权所有&nbsp;&nbsp;|&nbsp;&nbsp;</a>
      <a style="font-size: 12px;color: #BDBDBD" href="http://h5.platform.winlesson.com/e/de?" target="_blank">隐私政策&nbsp;&nbsp;|&nbsp;&nbsp;</a>
      <a style="font-size: 12px;color: #BDBDBD" href="https://h5.platform.winlesson.com/e/ae?" target="_blank">用户协议</a>
    </div>
    <div style="display: flex;flex-direction: row;margin-top: 10px">
      <a style="color: #BDBDBD;font-size: 12px;">友情链接&nbsp;&nbsp;|&nbsp;&nbsp;</a>
      <a style="font-size: 12px;color: #BDBDBD" href="http://www.gjgwy.org/" target="_blank">公考资讯网&nbsp;&nbsp;|&nbsp;&nbsp;</a>
      <a style="font-size: 12px;color: #BDBDBD" href="http://www.gjgwy.net/" target="_blank">公考资料网&nbsp;&nbsp;|&nbsp;&nbsp;</a>
      <a style="font-size: 12px;color: #BDBDBD" href="http://www.100chuan.cn" target="_blank">百川教育</a>
    </div>
    <a style="font-size: 12px;color: #bdbdbd;margin-top: 10px" href="https://beian.miit.gov.cn/" target="_blank">
      必胜公考备案信息 京ICP备16001403号-1 京公网安备11010802028868
    </a>
  </div>
</template>

<script>
export default {
  name: 'bskfooter',
  data() {
    return {
      msg: ''
    }
  },
  methods: {
    // 选择视频：
    gotoTop: function () {
      $('html,body').animate({scrollTop: '0px'}, 1000);
    }
  }
}
</script>

<style scoped>

.bsk_footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  background-color: #ffffff;
  color: #5c5c5c;
  padding-top: 15px;
  padding-bottom: 15px;
  border-top: 2px #f2f2f2 solid;
}

.urlimg {
  border-radius: 8px;
  width: 150px;
  height: 75px;
}

</style>



// WEBPACK FOOTER //
// src/components/Layout/bskFooter.vue